module.exports = __webpack_public_path__ + "img/13.fd848e78.jpg";